export default __webpack_public_path__ + "static/olive-tall-two-334c70053c908bbb2eb60a8cde803eb2.jpg";